/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import i18n from 'i18next';
import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import {
  safelyInitI18nForTestsAndStories,
  SHARED_NAMESPACE,
  sharedTranslations,
} from '@opengeoweb/shared';
import dataexplorerTranslations from '../../../locales/dataexplorer.json';

export const DATA_EXPLORER_NAMESPACE = 'dataexplorer';

export const initDataExplorerI18n = (): void => {
  safelyInitI18nForTestsAndStories(i18n, DATA_EXPLORER_NAMESPACE, [
    { ns: DATA_EXPLORER_NAMESPACE, translations: dataexplorerTranslations },
    { ns: SHARED_NAMESPACE, translations: sharedTranslations },
  ]);
};

const ns = [DATA_EXPLORER_NAMESPACE, SHARED_NAMESPACE];

export const translateInTestsAndStories = (
  key: string,
  params: Record<string, string | number> | undefined = undefined,
): string => i18n.t(key, { ns, ...params });

export const useDataExplorerTranslation = (): UseTranslationResponse<
  typeof DATA_EXPLORER_NAMESPACE,
  typeof i18n
> => useTranslation(DATA_EXPLORER_NAMESPACE);
